import { useBackgroundDispatch, useDebounced } from 'src/hooks'
import {
  getBillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics,
  getBillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatistics,
  getBillPayCardsPendingRequestsCountStatistics,
  getBudgetsUserMeCountStatistics,
  getCreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveDelegateCountStatistics,
  getCreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatistics,
  getCreditCardsActiveSourceCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveSourceCountStatistics,
  getCreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatistics,
  getCreditCardsActiveStandardCanIssueVirtualCardsCountStatistics,
  getCreditCardsCanIssueVirtualCardsCountStatistics,
  getCreditCardsCountStatistics,
  getCreditCardsDelegateCountStatistics,
  getCreditCardsDelegateOwnerMeCountStatistics,
  getCreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatistics,
  getCreditCardsPendingSourceUserMeCountStatistics,
  getCreditCardsPendingSourceUserOrViewerMeCountStatistics,
  getCreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatistics,
  getCreditCardsSourceBudgetsEnabledCountStatistics,
  getCreditCardsSourceCountStatistics,
  getCreditCardsSourceUserOrViewerCountStatistics,
  getCreditCardsTimedOutSourceCountStatistics,
  getCreditCardsUserOrViewerMeCountStatistics,
  getGuestVirtualCardsRecipientMeCountStatistics,
  getVirtualCardsActiveOrPendingRecipientMeCountStatistics,
  getVirtualCardsActiveRecipientMeCountStatistics,
  getVirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics,
  getVirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatistics,
  getVirtualCardsCardholderPendingRequestOrApproverRuleApprovalMeCountStatistics,
  getVirtualCardsInactiveRecipientMeIssuedCountStatistics,
  getVirtualCardsPendingRequestCardholderMeCountStatistics,
  getVirtualCardsRecipientMeCountStatistics,
} from 'src/queries/statistics/statistics.actions'

export enum appStatisticsKeys {
  CreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveSourceCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveSourceCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveStandardCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveStandardCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatistics = 'CreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatistics',
  CreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatistics = 'CreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatistics',
  VirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics = 'VirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics',
  VirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatistics = 'VirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatistics',
  BillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics = 'BillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics',
  BillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatistics = 'BillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatistics',
  BillPayCardsPendingRequestsCountStatistics = 'BillPayCardsPendingRequestsCountStatistics',
  CreditCardsCanIssueVirtualCardsCountStatistics = 'CreditCardsCanIssueVirtualCardsCountStatistics',
  CreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatistics = 'CreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatistics',
  CreditCardsSourceBudgetsEnabledCountStatistics = 'CreditCardsSourceBudgetsEnabledCountStatistics',
  CreditCardsUserOrViewerMeCountStatistics = 'CreditCardsUserOrViewerMeCountStatistics',
  VirtualCardsPendingRequestCardholderMeCountStatistics = 'VirtualCardsPendingRequestCardholderMeCountStatistics',
  CreditCardsPendingSourceUserOrViewerMeCountStatistics = 'CreditCardsPendingSourceUserOrViewerMeCountStatistics',
  VirtualCardsRecipientMeCountStatistics = 'VirtualCardsRecipientMeCountStatistics',
  GuestVirtualCardsRecipientMeCountStatistics = 'GuestVirtualCardsRecipientMeCountStatistics',
  VirtualCardsInactiveRecipientMeIssuedCountStatistics = 'VirtualCardsInactiveRecipientMeIssuedCountStatistics',
  VirtualCardsActiveOrPendingRecipientMeCountStatistics = 'VirtualCardsActiveOrPendingRecipientMeCountStatistics',
  VirtualCardsActiveRecipientMeCountStatistics = 'VirtualCardsActiveRecipientMeCountStatistics',
  VirtualCardsCardholderPendingRequestOrApproverRuleApprovalCountStatistics = 'VirtualCardsCardholderPendingRequestOrApproverRuleApprovalCountStatistics',
  CreditCardsActiveDelegateCountStatistics = 'CreditCardsActiveDelegateCountStatistics',
  CreditCardsActiveSourceCountStatistics = 'CreditCardsActiveSourceCountStatistics',
  CreditCardsPendingSourceUserMeCountStatistics = 'CreditCardsPendingSourceUserMeCountStatistics',
  CreditCardsTimedOutSourceCountStatistics = 'CreditCardsTimedOutSourceCountStatistics',
  CreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatistics = 'CreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatistics',
  CreditCardsDelegateCountStatistics = 'CreditCardsDelegateCountStatistics',
  CreditCardsDelegateOwnerMeCountStatistics = 'CreditCardsDelegateOwnerMeCountStatistics',
  CreditCardsDelegateUserMeCountStatistics = 'CreditCardsDelegateUserMeCountStatistics',
  CreditCardsSourceCountStatistics = 'CreditCardsSourceCountStatistics',
  CreditCardsSourceUserOrViewerCountStatistics = 'CreditCardsSourceUserOrViewerCountStatistics',
  CreditCardsCountStatistics = 'CreditCardsCountStatistics',
}

export const useDebouncedStatsDispatcher = (
  waitTime: number,
): ((stats: appStatisticsKeys[], cacheTimestamp?: string) => void) => {
  const dispatch = useBackgroundDispatch()

  const {
    debouncedF: dispatchCreditCardsActiveCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(getCreditCardsActiveCanIssueVirtualCardsCountStatistics())
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveSourceCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(getCreditCardsActiveSourceCanIssueVirtualCardsCountStatistics())
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveStandardCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveStandardCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchCreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchVirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getVirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchVirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getVirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchBillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getBillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchBillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getBillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const { debouncedF: dispatchBillPayCardsPendingRequestsCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getBillPayCardsPendingRequestsCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsCanIssueVirtualCardsCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getCreditCardsCanIssueVirtualCardsCountStatistics())
      },
      waitTime,
      true,
    )

  const {
    debouncedF:
      dispatchCreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const { debouncedF: dispatchCreditCardsSourceBudgetsEnabledCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getCreditCardsSourceBudgetsEnabledCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsUserOrViewerMeCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getCreditCardsUserOrViewerMeCountStatistics())
      },
      waitTime,
      true,
    )

  const {
    debouncedF: dispatchVirtualCardsPendingRequestCardholderMeCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(getVirtualCardsPendingRequestCardholderMeCountStatistics())
    },
    waitTime,
    true,
  )

  const {
    debouncedF: dispatchCreditCardsPendingSourceUserOrViewerMeCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(getCreditCardsPendingSourceUserOrViewerMeCountStatistics())
    },
    waitTime,
    true,
  )

  const { debouncedF: dispatchCreditCardsPendingSourceUserMeCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getCreditCardsPendingSourceUserMeCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchVirtualCardsRecipientMeCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getVirtualCardsRecipientMeCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchGuestVirtualCardsRecipientMeCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getGuestVirtualCardsRecipientMeCountStatistics())
      },
      waitTime,
      true,
    )

  const {
    debouncedF: dispatchVirtualCardsInactiveRecipientMeIssuedCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(getVirtualCardsInactiveRecipientMeIssuedCountStatistics())
    },
    waitTime,
    true,
  )

  const {
    debouncedF: dispatchVirtualCardsActiveOrPendingRecipientMeCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(getVirtualCardsActiveOrPendingRecipientMeCountStatistics())
    },
    waitTime,
    true,
  )

  const {
    debouncedF:
      dispatchVirtualCardsCardHolderPendingRequestOrApproverRuleApprovalCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getVirtualCardsCardholderPendingRequestOrApproverRuleApprovalMeCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const { debouncedF: dispatchVirtualCardsActiveRecipientMeCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getVirtualCardsActiveRecipientMeCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsActiveDelegateCountStatistics } =
    useDebounced(
      (cacheTimestamp?: string): void => {
        dispatch(getCreditCardsActiveDelegateCountStatistics(cacheTimestamp))
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsActiveSourceCountStatistics } =
    useDebounced(
      (cacheTimestamp?: string): void => {
        dispatch(getCreditCardsActiveSourceCountStatistics(cacheTimestamp))
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsTimedOutSourceCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getCreditCardsTimedOutSourceCountStatistics())
      },
      waitTime,
      true,
    )

  const {
    debouncedF:
      dispatchCreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatistics,
  } = useDebounced(
    (): void => {
      dispatch(
        getCreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatistics(),
      )
    },
    waitTime,
    true,
  )

  const { debouncedF: dispatchCreditCardsDelegateCountStatistics } =
    useDebounced(
      (cacheTimestamp?: string): void => {
        dispatch(getCreditCardsDelegateCountStatistics(cacheTimestamp))
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsDelegateOwnerMeCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getCreditCardsDelegateOwnerMeCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsDelegateUserMeCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getBudgetsUserMeCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsSourceCountStatistics } = useDebounced(
    (cacheTimestamp?: string): void => {
      dispatch(getCreditCardsSourceCountStatistics(cacheTimestamp))
    },
    waitTime,
    true,
  )

  const { debouncedF: dispatchCreditCardsSourceUserOrViewerCountStatistics } =
    useDebounced(
      (): void => {
        dispatch(getCreditCardsSourceUserOrViewerCountStatistics())
      },
      waitTime,
      true,
    )

  const { debouncedF: dispatchCreditCardsCountStatistics } = useDebounced(
    (): void => {
      dispatch(getCreditCardsCountStatistics())
    },
    waitTime,
    true,
  )

  const dispatchStats = (
    stats: appStatisticsKeys[],
    cacheTimestamp?: string,
  ): void => {
    stats.forEach((stat: appStatisticsKeys) => {
      switch (stat) {
        case appStatisticsKeys.CreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveBalanceLockEnabledCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveSourceBalanceLockEnabledCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveRecurrenceEnabledCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveDirectEnabledCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveSourceCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveSourceCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveSourceRecurrenceEnabledCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveStandardCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveStandardCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveSourceStandardCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsActiveSourceDirectEnabledCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatistics:
          dispatchCreditCardsActiveSourceBudgetsEnabledCanIssueBudgetsCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics:
          dispatchVirtualCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatistics:
          dispatchVirtualCardsCardholderOrViewerMeActiveAndInactiveCountStatistics()
          break
        case appStatisticsKeys.BillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics:
          dispatchBillPayCardsActiveSourceUserOrViewerOrDelegateUserMeCountStatistics()
          break
        case appStatisticsKeys.BillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatistics:
          dispatchBillPayCardsCardholderOrViewerMeActiveAndInactiveCountStatistics()
          break
        case appStatisticsKeys.BillPayCardsPendingRequestsCountStatistics:
          dispatchBillPayCardsPendingRequestsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsCanIssueVirtualCardsCountStatistics:
          dispatchCreditCardsCanIssueVirtualCardsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatistics:
          dispatchCreditCardsSourceBudgetsEnabledCanIssueBudgetsCountStatistics()
          break
        case appStatisticsKeys.CreditCardsSourceBudgetsEnabledCountStatistics:
          dispatchCreditCardsSourceBudgetsEnabledCountStatistics()
          break
        case appStatisticsKeys.CreditCardsUserOrViewerMeCountStatistics:
          dispatchCreditCardsUserOrViewerMeCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsPendingRequestCardholderMeCountStatistics:
          dispatchVirtualCardsPendingRequestCardholderMeCountStatistics()
          break
        case appStatisticsKeys.CreditCardsPendingSourceUserOrViewerMeCountStatistics:
          dispatchCreditCardsPendingSourceUserOrViewerMeCountStatistics()
          break
        case appStatisticsKeys.CreditCardsPendingSourceUserMeCountStatistics:
          dispatchCreditCardsPendingSourceUserMeCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsRecipientMeCountStatistics:
          dispatchVirtualCardsRecipientMeCountStatistics()
          break
        case appStatisticsKeys.GuestVirtualCardsRecipientMeCountStatistics:
          dispatchGuestVirtualCardsRecipientMeCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsInactiveRecipientMeIssuedCountStatistics:
          dispatchVirtualCardsInactiveRecipientMeIssuedCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsActiveOrPendingRecipientMeCountStatistics:
          dispatchVirtualCardsActiveOrPendingRecipientMeCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsCardholderPendingRequestOrApproverRuleApprovalCountStatistics:
          dispatchVirtualCardsCardHolderPendingRequestOrApproverRuleApprovalCountStatistics()
          break
        case appStatisticsKeys.VirtualCardsActiveRecipientMeCountStatistics:
          dispatchVirtualCardsActiveRecipientMeCountStatistics()
          break
        case appStatisticsKeys.CreditCardsActiveDelegateCountStatistics:
          dispatchCreditCardsActiveDelegateCountStatistics(cacheTimestamp)
          break
        case appStatisticsKeys.CreditCardsActiveSourceCountStatistics:
          dispatchCreditCardsActiveSourceCountStatistics(cacheTimestamp)
          break
        case appStatisticsKeys.CreditCardsTimedOutSourceCountStatistics:
          dispatchCreditCardsTimedOutSourceCountStatistics()
          break
        case appStatisticsKeys.CreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatistics:
          dispatchCreditCardsPendingSourceNeedCardholderVerificationUserOrViewerMeCountStatistics()
          break
        case appStatisticsKeys.CreditCardsDelegateCountStatistics:
          dispatchCreditCardsDelegateCountStatistics()
          break
        case appStatisticsKeys.CreditCardsDelegateOwnerMeCountStatistics:
          dispatchCreditCardsDelegateOwnerMeCountStatistics()
          break
        case appStatisticsKeys.CreditCardsDelegateUserMeCountStatistics:
          dispatchCreditCardsDelegateUserMeCountStatistics()
          break
        case appStatisticsKeys.CreditCardsSourceCountStatistics:
          dispatchCreditCardsSourceCountStatistics(cacheTimestamp)
          break
        case appStatisticsKeys.CreditCardsSourceUserOrViewerCountStatistics:
          dispatchCreditCardsSourceUserOrViewerCountStatistics()
          break
        case appStatisticsKeys.CreditCardsCountStatistics:
          dispatchCreditCardsCountStatistics()
          break
        default:
          break
      }
    })
  }

  return dispatchStats
}

export interface UseGlobalDebouncedDispatcherReturn {
  debouncedStatisticsDispatcher: (
    stats: appStatisticsKeys[],
    cacheTimestamp?: string,
  ) => void
}

export const useGlobalDebouncedDispatcher =
  (): UseGlobalDebouncedDispatcherReturn => {
    const waitTime = 500

    const debouncedStatisticsDispatcher = useDebouncedStatsDispatcher(waitTime)

    return {
      debouncedStatisticsDispatcher,
    }
  }
